(function () {
  'use strict';

  var openModal = null;
  var lastFocusedTrigger = null;

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  }

  function openModalById(id, trigger) {
    var modal = document.getElementById(id);
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ingredient-modal-open');

    openModal = modal;
    lastFocusedTrigger = trigger || null;

    var closeBtn = modal.querySelector('.ingredient-modal__close');
    if (closeBtn) closeBtn.focus();

    document.addEventListener('keydown', handleKeydown);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ingredient-modal-open');
    openModal = null;
    document.removeEventListener('keydown', handleKeydown);

    if (lastFocusedTrigger) {
      lastFocusedTrigger.focus();
      lastFocusedTrigger = null;
    }
  }

  function handleKeydown(event) {
    if (!openModal) return;

    if (event.key === 'Escape') {
      closeModal(openModal);
      return;
    }

    if (event.key === 'Tab') {
      var focusable = getFocusableElements(openModal);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ingredient-trigger]');
    if (trigger) {
      var targetId = trigger.getAttribute('data-modal-target');
      openModalById(targetId, trigger);
      return;
    }

    var closeEl = event.target.closest('[data-modal-close]');
    if (closeEl) {
      var modal = closeEl.closest('[data-ingredient-modal]');
      closeModal(modal);
    }
  });

  document.addEventListener('shopify:section:unload', function () {
    if (openModal) closeModal(openModal);
  });
})();
